export default class InvoiceRowModel {
	constructor(data = {}) {
		this.invoice_id = data.invoice_id;
		this.type = data.type;
		this.fee = data.misc_fee;
		this.title = data.misc_title;
		this.factory_evaluation_id = data.factory_evaluation_id;
	}
}
